document.addEventListener("alpine:init", () => {
  Alpine.data("notificationsController", () => ({
    notifications: [],
    filter: "",
    pageInfo: {
      start_cursor: "",
      end_cursor: "",
      has_next_page: false,
      has_previous_page: false,
    },
    isLoading: false,
    keepLoading: true,

    setup() {
      this.filter = "or";
      // Load more when the loading svg isIntersecting
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.pageInfo.has_next_page) {
            this.loadMore();
          }

          if (!entry.isIntersecting) {
            this.keepLoading = false;
          }
        });
      };

      // Trigger observer whenever the loading svg is 50% shown
      let options = {
        threshold: 0.5,
      };

      let observer = new IntersectionObserver(callback, options);
      observer.observe(document.querySelector("#load-more-notifications"));

      this.loadMore();
    },

    shouldShow(notification) {
      switch (this.filter) {
        case "":
          return true;
        case "unread":
          return !notification.read;
        case "unresolved":
          return !notification.resolved_at;
        case "or":
          return !notification.read || !notification.resolved_at;
        case "and":
          return !notification.read && !notification.resolved_at;
        default:
          return true;
      }
    },

    loadMore() {
      const $dispatch = this.$dispatch;

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      let notificationsURL =
        "/notifications/json/?after=" + this.pageInfo.end_cursor;

      fetch(notificationsURL, {
        credentials: "include",
        method: "GET",
      })
        .then(window.status)
        .then(window.json)
        .then(
          function(data) {
            data.success?.forEach(function(message) {
              $dispatch("notify", { msg: message, type: "success" });
            });
            data.error?.forEach(function(message) {
              $dispatch("notify", { msg: message, type: "error" });
            });
            if (data.redirect_to !== "") {
              window.location = data.redirect_to;
            }

            let respData = data.data;

            if (respData?.pageInfo) {
              this.pageInfo = respData?.pageInfo;
            }
            if (respData?.notifications) {
              this.notifications = this.notifications.concat(
                respData.notifications,
              );
            }
          }.bind(this),
        )
        .catch(
          function(err) {
            this.keepLoading = false;
            console.log("Fetch Error :-S", err);
            $dispatch("notify", {
              msg: "Error getting notifications",
              type: "error",
            });
          }.bind(this),
        )
        .finally(
          function() {
            this.isLoading = false;
            if (this.pageInfo.has_next_page && this.keepLoading) {
              this.loadMore();
            }
          }.bind(this),
        );
    },

    update(updatedN) {
      for (var i = 0; i < this.notifications.length; i++) {
        let oldN = this.notifications[i];

        if (oldN.id !== updatedN.id) {
          continue;
        }

        this.notifications[i] = updatedN;
        return;
      }
      // If we get here, the notification was not in the notifications array
      this.$dispatch("notify", {
        msg: "unknown notifciation with id " + updatedN.id,
        type: "error",
      });
    },

    doAction(notificationID, actionID) {
      const $dispatch = this.$dispatch;

      let form = new FormData();
      form.append("action", actionID);

      fetch("/notifications/" + notificationID + "/do", {
        credentials: "include",
        method: "POST",
        body: form,
      })
        .then(window.status)
        .then(window.json)
        .then(function(data) {
          data.success?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "success" });
          });

          data.error?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "error" });
          });

          if (data.redirect_to !== "") {
            window.location = data.redirect_to;
          }

          if (data.open !== "") {
            window.open(data.open, "_blank", "noopener");
          }

          $dispatch("update", data.data);
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
          $dispatch("notify", {
            msg: 'Error while doing action: "' + actionID + '"',
            type: "error",
          });
        });
    },
  }));
});
